import { useLocation } from "react-router-dom";

// Pre-formatted WhatsApp link — replace number with verified business WhatsApp.
const WA_NUMBER = "971581799090";
const WA_MESSAGE = encodeURIComponent(
  "Hi Trawelldmc! I'd like to plan a trip. Please share your packages.",
);
const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`;

export default function WhatsAppFab() {
  const location = useLocation();
  // Don't render on the admin or AI quote pages (they already have ChatWidget logic)
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 bg-[#25D366] text-white pl-3 pr-5 py-3 shadow-2xl hover:bg-[#1FB257] transition-colors"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="22"
        height="22"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.717 2.735.717a.794.794 0 0 0 .137-.014c.473-.058 1.404-.501 1.62-.945.157-.328.157-.616.114-.945-.072-.07-.157-.0114-.286-.157zM16.272 0c-8.738.001-16.272 7.117-16.272 15.808 0 2.78.731 5.503 2.114 7.897L0 32l8.498-2.213c2.294 1.247 4.886 1.918 7.512 1.918h.005c8.738 0 16.272-7.118 16.272-15.81-.011-4.214-1.668-8.18-4.673-11.16C24.612 1.654 20.557.003 16.272 0zm0 28.948h-.003c-2.347 0-4.66-.628-6.673-1.819l-.473-.283-4.973 1.292 1.32-4.823-.314-.494a13.057 13.057 0 0 1-2.012-6.961c.003-7.214 5.93-13.082 13.13-13.082 3.51 0 6.808 1.342 9.286 3.793a13.013 13.013 0 0 1 3.846 9.29c-.004 7.214-5.93 13.087-13.134 13.087z" />
      </svg>
      <div className="text-left leading-tight">
        <div className="font-heading text-sm font-semibold">WhatsApp</div>
        <div className="text-[11px] text-white/80">Instant DMC support</div>
      </div>
    </a>
  );
}
